import React from 'react';
import { connect } from 'react-redux';
import DashCard from './DashCard';
import ReleaseEvent from '../Calendar/ReleaseEvent';
import * as actions from '../../actions/calendar';
import moment from 'moment';

/**
 * Render the release card.
 * Display the next release events.
 */
class CalendarReleaseCard extends React.Component {
    componentDidMount() {
        this.props.fetchReleaseCalendar();

        this.fetchReleaseInterval = setInterval(
            function() {
                this.props.fetchReleaseCalendar();
            }.bind(this),
            60 * 60 * 1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.fetchReleaseInterval);
    }

    render() {
        const { releaseEvents } = this.props;
        const isQA =
            releaseEvents !== undefined &&
            releaseEvents.length > 1 &&
            releaseEvents[0].type === 'release';
        const daysBeforeNextEvent =
            releaseEvents !== undefined && releaseEvents.length > 1
                ? moment(releaseEvents[0].start.date).diff(
                      moment().startOf('day'),
                      'days'
                  )
                : undefined;

        return (
            <DashCard title="Release" className="release">
                {!isQA && daysBeforeNextEvent <= 3 && (
                    <div className="release--beta-alert">
                        <span>
                            Beta in <strong>{daysBeforeNextEvent + 1}</strong> days
                        </span>
                    </div>
                )}
                <div className="">
                    {releaseEvents !== undefined &&
                        releaseEvents.map((event, index) => (
                            <ReleaseEvent event={event} key={index} />
                        ))}
                </div>
            </DashCard>
        );
    }
}

function mapStateToProps(state) {
    return {
        releaseEvents: state.calendar.releaseEvents,
        isApiLoaded: state.calendar.isApiLoaded,
    };
}

export default connect(
    mapStateToProps,
    actions
)(CalendarReleaseCard);



// WEBPACK FOOTER //
// ./src/components/Cards/CalendarReleaseCard.js